import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { assets, faqs } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="relative bg-cream-deep pb-14 pt-6 sm:pb-20 sm:pt-8" data-id="element-26" data-mp="1bmvcovcc04q6">
      {/* Hijo único de esta sección: asoma por encima de su borde superior con margen negativo,
          así no depende del overflow de la sección anterior. */}
      <div className="pointer-events-none relative -mt-12 h-[150px] sm:-mt-14 sm:h-[160px] lg:h-[170px]" data-id="element-27" data-mp="289q7p1t4mv5f">
        <img src={assets.dogPeeking} alt="" aria-hidden="true" className="absolute bottom-0 right-4 w-[195px] select-none sm:right-8 sm:w-[205px] lg:right-6 lg:w-[220px]" data-id="element-28" data-mp="1uilgmo3trb6p" />
      </div>

      <div className="relative z-10 mx-auto mt-4 max-w-3xl px-5 sm:px-8" data-id="element-29" data-mp="2n5z6y3d0p8hu">
        <h2 className="text-center font-display text-3xl font-semibold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-30" data-mp="2s0br6fmbinun">
          Preguntas frecuentes
        </h2>

        <ul className="mt-9 space-y-2.5" data-id="element-31" data-mp="10ui08xwaug2x">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-32" data-mp="1emenoon0w1sz" data-mpi={i}>
                <h3 data-id="element-33" data-mp="19t2e9lqx01kt">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors duration-150 ease-soft hover:bg-cream/60 sm:px-6" data-id="element-34" data-mp="19sk6bruw3yx2">
                    <span className="font-sans text-[15px] font-semibold text-petrol sm:text-base" data-id="element-35" data-mp="35yhzn19szjb">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-4 w-4 shrink-0 text-petrol-muted transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} strokeWidth={2.4} aria-hidden="true" data-id="element-36" data-mp="3udsveyotfr75" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-37" data-mp="2c9nqak1qxdq4">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-38" data-mp="2h8quy3dtdhxk">
                      <p className="px-5 pb-5 font-sans text-[15px] leading-relaxed text-petrol/75 sm:px-6" data-id="element-39" data-mp="2zzi1yyabww8s">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}